import { HotelPricingSummary } from '@rx-applications/clientsite/shared/utils';

export function hasRoomexExclusiveRate(hotel: HotelPricingSummary): boolean {
  return !!(
    hotel.isStandardRate ||
    (hotel.tags &&
      hotel.tags
        .map((tag: string) => tag.split('promo:'))
        .reduce((accumulator, value) => accumulator.concat(value), [])
        .findIndex((promo) => promo.length && +promo > 0) !== -1)
  );
}
